import CareerItem from "components/career-item/career-item.component";
import { Education } from "interfaces/CareerInfoInterface";
import React from "react";

const GlimpseEducationSection: React.FC<Education> = ({
  label,
  title,
  className,
  description,
  duration,
  image,
  unit,
}) => {
  const formatDuration = (value: string | number | null | undefined) => {
    if (value === null || value === undefined || value === "") return "";
    const num = Number(value);
    if (isNaN(num)) return "";
    if (num === 0) return "0";
    return Number.isInteger(num) ? num : num.toString().replace(/\.0+$/, "");
  };
  return (
    <div className={`block justify-center items-center ${className}`}>
      <div className="flex justify-center pb-2">
        <img src={image} alt={label} className="w-[85px] h-[85px]" onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = "/assets/icons/Certification.png";
        }} />
      </div>

      <div className="w-full font-bold leading-4 text-md tracking-wide text-center text-green">
        {title}
      </div>
      <div className="w-full font-normal text-sm leading-4 capitalize text-gray mt-1">
        {description}
      </div>
      <div className="w-full pt-2 text-sm leading-3 tracking-wide">
        {formatDuration(duration)} {unit}
        {}
      </div>
    </div>
  );
};

export default GlimpseEducationSection;
